import { render, staticRenderFns } from "./ButtonAddPages.vue?vue&type=template&id=6a5d96cc&scoped=true&"
import script from "./ButtonAddPages.vue?vue&type=script&lang=js&"
export * from "./ButtonAddPages.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAddPages.vue?vue&type=style&index=0&id=6a5d96cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5d96cc",
  null
  
)

export default component.exports